/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".small-header[_ngcontent-%COMP%]{font-size:10px;font-weight:700;text-transform:uppercase;color:#1a3349;margin-bottom:8px}.card-number[_ngcontent-%COMP%]{font-size:12px;color:#1a3349}.card-expiry[_ngcontent-%COMP%]{font-size:12px;color:#366bf3}.hidden-letters[_ngcontent-%COMP%]{letter-spacing:1.5px}.right[_ngcontent-%COMP%]{text-align:right}.center[_ngcontent-%COMP%]{text-align:center}"];
export { styles as styles };
